import { Checkbox, FormControlLabel } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import React from "react";

import { SortTypes } from "constants/app.enum";
import CommonStyles from "theme/CommonStyles";
import IconSort from "components/IconSort/IconSort";

interface Props {
  curSortOrder: "ASC" | "DESC";
  curSortField: SortTypes;
  onClick: (type: SortTypes) => void;
  onToggleSelectAll: (value: boolean) => void;
  allSelected: boolean;
  isAdmin: boolean;
}
function UsersListHeader({
  curSortOrder,
  curSortField,
  onClick,
  onToggleSelectAll,
  allSelected,
  isAdmin
}: Props): JSX.Element {
  const classes = CommonStyles();
  const { t } = useTranslation();

  const getSortOrder = (type: SortTypes) => {
    if (type === curSortField && curSortOrder === "ASC") {
      return "ASC";
    }
    if (type === curSortField && curSortOrder === "DESC") {
      return "DESC";
    }
    return null;
  };

  return (
    <header className={classes.header} aria-hidden>
      {isAdmin ? (
        <div className={`${classes.checkboxlistWraper}`}>
          <FormControlLabel
            value="view_monitor"
            control={<Checkbox color="default" />}
            label=""
            labelPlacement="end"
            checked={allSelected}
            onChange={(event, value) => {
              onToggleSelectAll(value);
            }}
          />
        </div>
      ) : (
        <></>
      )}
      <div
        aria-hidden
        onClick={() => onClick(SortTypes?.UserNameSort)}
        className={classes.colHeader}
      >
        <span>{t("User Id")}</span>{" "}
        <IconSort activeSortOrder={getSortOrder(SortTypes?.UserNameSort)} />
      </div>
      <div className={classes.colHeader}>
        <span>{t("Device Name")}</span>
      </div>
      <div className={classes.colHeader}>
        <span>{t("Belongs to User Groups")}</span>
      </div>
      <div className={classes.colHeader} onClick={() => null} aria-hidden>
        <span>{t("Sex")}</span>
      </div>
      <div className={`${classes.colHeader} ${classes.txtCenter}`}>
        <span className={classes.floatNone}>{t("Birth Year")}</span>
      </div>
      {isAdmin ? (
        <div className={`${classes.colHeader} ${classes.txtCenter}`}>
          <span className={classes.floatNone}>{t("Actions")}</span>
        </div>
      ) : (
        <></>
      )}
    </header>
  );
}

export default UsersListHeader;
